import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class FlowProgressStep extends Component {
  render() {
    var stepNumber = this.props.number;
    var stepName = this.props.name;
    var stepRequestedData = this.props.requestedData;
    var stepUserData = this.props.userData;
    var stepStatus = this.props.status;

    let className = cx({
      flowProgressStep: true,
      [`${stepStatus}`]: stepStatus,
    });

    return (
      <div className={classnames(className)}>
        <div className="number">{stepNumber}</div>
        <div className="name">{stepName}</div>

        {stepUserData && <div className="userData">{stepUserData}</div>}

        {!stepUserData && <div className="userRequestedData">{stepRequestedData}</div>}
      </div>
    );
  }
}
